// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Nmvq","content":"styles_content__3ycnM","selectAll":"styles_selectAll__24f12"};